{
  "version": "1.2.6",
  "objects": {
    "7540353582134736319": {
      "type": "frame",
      "id": "7540353582134736319",
      "z": 11847,
      "textContent": "",
      "left": 5997.7852444241635,
      "top": 1275.8378263818981,
      "width": 400,
      "height": 500,
      "scaleX": 1.3618810523776936,
      "scaleY": 0.8948161264757254,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a01A5",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7540353582120022934": {
      "type": "frame",
      "id": "7540353582120022934",
      "z": 10721,
      "textContent": "",
      "left": 6017.7852444241635,
      "top": 1295.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.45473191076673647,
      "scaleY": 0.4929405463952126,
      "fill": "#854AD7",
      "opacity": 0.05,
      "container": "7540353582134736319",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7540353582119662550": {
      "type": "frame",
      "id": "7540353582119662550",
      "z": 10817,
      "textContent": "",
      "left": 6443.537665375241,
      "top": 1295.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.07117117117117117,
      "scaleY": 0.4929405463952126,
      "fill": "transparent",
      "opacity": 1,
      "container": "7540353582120022934",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zz77q",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "parent",
      "layoutGap": 3,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7540353582131906770": {
      "type": "wireframe",
      "id": "7540353582131906770",
      "z": 10823,
      "top": 1429.8817471304021,
      "left": 6464.037665375241,
      "width": 52,
      "height": 52,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7540353582119662550",
      "layoutPosition": "a1BZQ",
      "wireframeName": "avatar",
      "fill": "#854AD7",
      "textColor": "#333333",
      "style": "round",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "angle-right" },
        "iconRight": null
      },
      "showBackground": true,
      "showOutline": false
    },
    "7540353582128439242": {
      "type": "frame",
      "id": "7540353582128439242",
      "z": 10817,
      "textContent": "",
      "left": 6017.7852444241635,
      "top": 1295.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.07117117117117117,
      "scaleY": 0.4929405463952126,
      "fill": "transparent",
      "opacity": 1,
      "container": "7540353582120022934",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zx9wZ",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "parent",
      "layoutGap": 3,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7540353582132419645": {
      "type": "wireframe",
      "id": "7540353582132419645",
      "z": 10837,
      "top": 1429.8817471304021,
      "left": 6038.2852444241635,
      "width": 52,
      "height": 52,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7540353582128439242",
      "layoutPosition": "a1BZQ",
      "wireframeName": "avatar",
      "fill": "#854AD7",
      "textColor": "#333333",
      "style": "round",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "angle-left" },
        "iconRight": null
      },
      "showBackground": true,
      "showOutline": false
    },
    "7540353582120740551": {
      "type": "shape",
      "id": "7540353582120740551",
      "z": 10967,
      "shapeName": "icon",
      "textContent": "",
      "left": 6212.832005941099,
      "top": 1392.552298171799,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1165889791720618,
      "scaleY": 1.1165889791720618,
      "stroke": "#5E49D6",
      "strokeWidth": 3,
      "opacity": 0.3,
      "borderOpacity": 1,
      "fill": "transparent",
      "angle": 0,
      "container": "7540353582120022934",
      "authorId": "7065717090579889052",
      "showAuthor": true,
      "layoutPosition": "ZyoKDIAC",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7540353582122322871": {
      "type": "frame",
      "id": "7540353582122322871",
      "z": 10722,
      "textContent": "",
      "left": 6017.7852444241635,
      "top": 1623.925667878906,
      "width": 400,
      "height": 500,
      "scaleX": 1.2618810523776938,
      "scaleY": 0.15864044348170955,
      "fill": "transparent",
      "opacity": 0.5,
      "container": "7540353582134736319",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7540353582126801192": {
      "type": "frame",
      "id": "7540353582126801192",
      "z": 10723,
      "textContent": "",
      "left": 6017.7852444241635,
      "top": 1632.4074871073105,
      "width": 1110,
      "height": 625,
      "scaleX": 0.06828114428694856,
      "scaleY": 0.09977053325447359,
      "fill": "#5E49D6",
      "opacity": 0.05,
      "container": "7540353582122322871",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7540353582124380386": {
      "type": "shape",
      "id": "7540353582124380386",
      "z": 10957,
      "shapeName": "icon",
      "textContent": "",
      "left": 6044.002987861397,
      "top": 1652.9074871073105,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.22356583284045992,
      "scaleY": 0.22356583284045992,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#7B27F0",
      "angle": 0,
      "container": "7540353582126801192",
      "authorId": "7065717090579889052",
      "showAuthor": true,
      "layoutPosition": "a01Qv",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7540353582122724954": {
      "type": "frame",
      "id": "7540353582122724954",
      "z": 10724,
      "textContent": "",
      "left": 6103.577314582676,
      "top": 1623.925667878906,
      "width": 1110,
      "height": 625,
      "scaleX": 0.06828114428694856,
      "scaleY": 0.12691235478536764,
      "fill": "#5E49D6",
      "opacity": 0.1,
      "container": "7540353582122322871",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7540353582133065501": {
      "type": "shape",
      "id": "7540353582133065501",
      "z": 10927,
      "shapeName": "icon",
      "textContent": "",
      "left": 6121.813238791505,
      "top": 1643.925667878906,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.3732022174085477,
      "scaleY": 0.3732022174085477,
      "stroke": "#5E49D6",
      "strokeWidth": 2,
      "opacity": 0.4,
      "borderOpacity": 1,
      "fill": "transparent",
      "angle": 0,
      "container": "7540353582122724954",
      "authorId": "7065717090579889052",
      "showAuthor": true,
      "layoutPosition": "a00Kk",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7540353582132002955": {
      "type": "frame",
      "id": "7540353582132002955",
      "z": 10725,
      "textContent": "",
      "left": 6189.369384741189,
      "top": 1632.4074871073105,
      "width": 1110,
      "height": 625,
      "scaleX": 0.06828114428694856,
      "scaleY": 0.09977053325447359,
      "fill": "#5E49D6",
      "opacity": 0.05,
      "container": "7540353582122322871",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7540353582119550816": {
      "type": "shape",
      "id": "7540353582119550816",
      "z": 10937,
      "shapeName": "icon",
      "textContent": "",
      "left": 6215.587128178422,
      "top": 1652.9074871073105,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.22356583284045992,
      "scaleY": 0.22356583284045992,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#7B27F0",
      "angle": 0,
      "container": "7540353582132002955",
      "authorId": "7065717090579889052",
      "showAuthor": true,
      "layoutPosition": "a00QD",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7540353582133475567": {
      "type": "frame",
      "id": "7540353582133475567",
      "z": 10726,
      "textContent": "",
      "left": 6275.161454899701,
      "top": 1632.4074871073105,
      "width": 1110,
      "height": 625,
      "scaleX": 0.06828114428694856,
      "scaleY": 0.09977053325447359,
      "fill": "#5E49D6",
      "opacity": 0.05,
      "container": "7540353582122322871",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7540353582119925264": {
      "type": "shape",
      "id": "7540353582119925264",
      "z": 10947,
      "shapeName": "icon",
      "textContent": "",
      "left": 6301.379198336935,
      "top": 1652.9074871073105,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.22356583284045992,
      "scaleY": 0.22356583284045992,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#7B27F0",
      "angle": 0,
      "container": "7540353582133475567",
      "authorId": "7065717090579889052",
      "showAuthor": true,
      "layoutPosition": "a08mN",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7540353582132987714": {
      "type": "frame",
      "id": "7540353582132987714",
      "z": 10727,
      "textContent": "",
      "left": 6360.953525058214,
      "top": 1632.4074871073105,
      "width": 1110,
      "height": 625,
      "scaleX": 0.06828114428694856,
      "scaleY": 0.09977053325447359,
      "fill": "#5E49D6",
      "opacity": 0.05,
      "container": "7540353582122322871",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7540353582127964421": {
      "type": "shape",
      "id": "7540353582127964421",
      "z": 10730,
      "shapeName": "icon",
      "textContent": "",
      "left": 6387.171268495447,
      "top": 1652.9074871073105,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.22356583284045992,
      "scaleY": 0.22356583284045992,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#7B27F0",
      "angle": 0,
      "container": "7540353582132987714",
      "authorId": "7065717090579889052",
      "showAuthor": true,
      "layoutPosition": "a08mN",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7540353582128665760": {
      "type": "frame",
      "id": "7540353582128665760",
      "z": 10728,
      "textContent": "",
      "left": 6446.7455952167265,
      "top": 1632.4074871073105,
      "width": 1110,
      "height": 625,
      "scaleX": 0.06828114428694856,
      "scaleY": 0.09977053325447359,
      "fill": "#5E49D6",
      "opacity": 0.05,
      "container": "7540353582122322871",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7540353582127064199": {
      "type": "shape",
      "id": "7540353582127064199",
      "z": 10729,
      "shapeName": "icon",
      "textContent": "",
      "left": 6472.96333865396,
      "top": 1652.9074871073105,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.22356583284045992,
      "scaleY": 0.22356583284045992,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#7B27F0",
      "angle": 0,
      "container": "7540353582128665760",
      "authorId": "7065717090579889052",
      "showAuthor": true,
      "layoutPosition": "a08mN",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    }
  }
}
